module.exports = __webpack_public_path__ + "315a977d5cc9106296a62e4f0b111f87.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/guohui.png
// module id = 532
// module chunks = 21 54 55 56 68 77 79 80 88